var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.06 7.85A3.81 3.81 0 0 0 8 6.66a3.82 3.82 0 0 0-2.1.65l.38-3.13h5.39V1.99H4.03l-.79 7.58 2.42.15c.12-.33.32-.59.6-.78s.68-.29 1.2-.29c.64 0 1.13.24 1.45.7.33.48.5 1.1.5 1.9 0 .72-.16 1.3-.46 1.76s-.78.67-1.42.67c-.56 0-1.01-.17-1.35-.5a1.9 1.9 0 0 1-.52-1.42l-2.64.13-.02.05c-.03 1.2.4 2.13 1.3 2.82a5.2 5.2 0 0 0 3.23 1.02c1.5 0 2.63-.43 3.43-1.3a4.64 4.64 0 0 0 1.19-3.25 4.9 4.9 0 0 0-1.09-3.38zm6.88 8.69V10.7h-1.9l-3.9 6.17.1 1.12h3.82V20h1.88v-2.02H19v-1.44h-1.06zm-1.88 0H13.9l1.97-3.1.15-.27.04.01v3.36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarks);
export default ForwardRef;